import axios from 'axios';
import { message } from 'antd';

import { BASE_URL } from '../constants/api-urls';
import {
  getAuth0RefreshToken,
  persistAuth0Grant,
  shouldRefreshAuth0Token,
} from './auth0Session';

let refreshPromise: Promise<string> | null = null;
let sessionExpiredHandled = false;

export async function refreshAuth0AccessToken(): Promise<string> {
  if (refreshPromise) {
    return refreshPromise;
  }

  const refreshToken = getAuth0RefreshToken();
  if (!refreshToken) {
    throw new Error('No Auth0 refresh token');
  }

  refreshPromise = (async () => {
    const response = await axios.post(`${BASE_URL}/auth0/refresh`, { refresh_token: refreshToken });
    const grant = response.data?.data;
    if (!response.data?.success || !grant?.access_token) {
      throw new Error(response.data?.message || 'Unable to refresh session');
    }

    persistAuth0Grant(grant);
    return grant.access_token as string;
  })();

  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
}

export async function ensureFreshAuth0AccessToken(): Promise<string | null> {
  if (!shouldRefreshAuth0Token()) {
    return null;
  }

  try {
    return await refreshAuth0AccessToken();
  } catch {
    return null;
  }
}

export function handleAuth0SessionExpired(notice = 'Your session has expired. Please log in again.') {
  if (sessionExpiredHandled) {
    return;
  }
  sessionExpiredHandled = true;
  message.warning(notice, 4);
  window.setTimeout(async () => {
    sessionExpiredHandled = false;
    const { Auth0Logout } = await import('../utils');
    Auth0Logout();
  }, 400);
}
